// @flow

import gql from 'graphql-tag';

export const HomeFragment = gql`
  fragment HomeFragment on NodeHomePage {
    entityLabel
    fieldMetaTags
    title
    fieldSubtitle
    fieldFile
    fieldFile2
    fieldShortDescription
  }
`;



// WEBPACK FOOTER //
// ./screens/App/screens/Home/fragments.js